import { Content, Title } from 'components';
import { Empty, Descriptions, Table } from 'antd';
import { stringToMoneyFormat } from 'utils';
import styles from '../styles';

const ProductOptionInformation = ({ data }) => {
  const options = data && data.product_option ? data.product_option : [];

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Title style={{ ...styles.subTitle }}>옵션 정보</Title>
      </div>
      {options.length === 0 ? (
        <div
          style={{
            width: '100%',
            height: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Empty />
        </div>
      ) : (
        options.map((item) => {
          return (
            <div key={item.option_id} style={{ marginBottom: '15px' }}>
              <Descriptions
                bordered
                size="middle"
                labelStyle={{
                  width: 160,
                  backgroundColor: '#F4F4F5',
                  color: 'black',
                }}
                column={2}
                items={[
                  { key: '1', label: '옵션명', children: item.option_title },
                  {
                    key: '2',
                    label: '필수 옵션 설정',
                    children:
                      item.type === 'REQUIRED' ? '필수 옵션' : '추가 옵션',
                  },
                  // {
                  //   key: '3',
                  //   label: '옵션 타입',
                  //   children:
                  //     item.option_type === 'COUNT' ? '추가 옵션' : '선택 옵션',
                  // },
                  {
                    key: '4',
                    label: '하위 옵션',
                    children: (
                      <Table
                        pagination={false}
                        dataSource={item.option}
                        columns={[
                          {
                            title: '옵션항목',
                            key: 'option_name',
                            dataIndex: 'option_name',
                            render: (title) => <span>{title}</span>,
                          },
                          {
                            title: '옵션항목 금액',
                            key: 'option_price',
                            dataIndex: 'option_price',
                            render: (price) => (
                              <span>{stringToMoneyFormat(price)}원</span>
                            ),
                          },
                          // {
                          //   title: '기본값',
                          //   dataIndex: 'default',
                          //   render: (value) => (
                          //     <Checkbox checked={value} disabled />
                          //   ),
                          // },
                        ]}
                      />
                    ),
                  },
                ]}
              />
            </div>
          );
        })
      )}
    </Content>
  );
};

export default ProductOptionInformation;
